import { IReuseOrderModel } from 'types';
import { useStyles } from './ReuseModelsItem.styles';
import { Modal } from '@mui/material';
import { ModalHeader, ModalVariant } from '../ModalHeader/ModalHeader';
import { CustomTypography } from '../Typography/Typography';
import { Grid, GridVariant } from 'app/shared/components/generic-ui';
import { useTranslation } from 'react-i18next';

const Labels: Record<
  Exclude<
    keyof IReuseOrderModel,
    | 'returnConcreteOrderDataId'
    | 'dispatchOrderId'
    | 'partitionDateUtc'
    | 'startDateTimeUtc'
    | 'chosenForReuse'
    | 'link'
  >,
  string
> = {
  mixDesign: 'reuseModelsItem.mixDesign',
  customer: 'reuseModelsItem.customer',
  project: 'reuseModelsItem.project',
  plant: 'reuseModelsItem.plant',
  remainingLoads: 'reuseModelsItem.remainingLoads',
  remainingQuantity: 'reuseModelsItem.remainingQuantity',
};

interface IReuseModalInfoProps {
  info: IReuseOrderModel;
  setInfo: (info: IReuseOrderModel | undefined) => void;
}

export const ReuseModalInfo = ({ info, setInfo }: IReuseModalInfoProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Modal
      open={!!info}
      onClose={() => setInfo(undefined)}
      className={classes.modal}
    >
      <div className={classes.wrapper}>
        <ModalHeader
          variant={ModalVariant.SMALL}
          header={`Reuse Concrete`}
          closeHandler={() => setInfo(undefined)}
        />
        <div className={classes.infoContainer}>
          <div className={classes.subheader}>
            <CustomTypography variant="header6" bold color="accentDark">
              {`${t('reuseModelsItem.dispatchOrder')} ${info?.dispatchOrderId}`}
            </CustomTypography>
          </div>
          {!!info && (
            <Grid container spacing={1}>
              {Object.entries(info).map(([key, value]) =>
                Labels[key as keyof typeof Labels] ? (
                  <div key={key} className={classes.sectionItem}>
                    <Grid item variant={GridVariant.MEDIUM}>
                      <CustomTypography
                        variant="caption2"
                        bold
                        color="greyscale2"
                      >
                        {t(Labels[key as keyof typeof Labels])}
                      </CustomTypography>
                    </Grid>
                    <Grid
                      item
                      variant={GridVariant.MEDIUM}
                      className={classes.valueContainer}
                    >
                      <CustomTypography variant="bodySmall" color="accentDark">
                        {typeof value === 'string' ? value : value.toString()}
                      </CustomTypography>
                    </Grid>
                  </div>
                ) : null,
              )}
            </Grid>
          )}
        </div>
      </div>
    </Modal>
  );
};
